// import { EntityId } from '@reduxjs/toolkit';

// export interface DataStoreModel<ModelType> {
// export interface DataStoreModel {
//   readonly id?: EntityId | string | undefined | null;
//   readonly type: ModelTypes;
// }
export type DataStoreModel = Readonly<
  { id: string; modelType: ModelTypes } & Record<string, any>
>;

// TODO: move into store to keep all dataStore configurations in one place and outside of dataStorePersistance 'library'
export enum ModelTypes {
  User = 'User',
  Assessment = 'Assessment',
  Player = 'Player',
  Notification = 'Notification',
  Conneqt = 'Conneqt',
  Incident = 'Incident',
  Team = 'Team',
  Account = 'Account',
}
